import setComponentAnswer from '@redux/actions/setComponentAnswer';

export const matrixAnswerQuestion = (params) => (dispatch) => {
  const { id, questionId, value } = params;
  dispatch(setComponentAnswer(value, questionId, id));
};

export default matrixAnswerQuestion;
